module.exports = __webpack_public_path__ + "img/std-rim.af3791a1.png";